function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_4",
  x: 0,
  y: 0,
  width: 53,
  height: 53,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dx: 2,
  dy: 2,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1.5,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1316",
  "data-name": "Group 1316",
  transform: "translate(-137.5 -343.5)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, 137.5, 343.5)",
  filter: "url(#Ellipse_4)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ellipse_4-2",
  "data-name": "Ellipse 4",
  transform: "translate(2.5 2.5)",
  fill: "#f5f5f5",
  stroke: "#e94e4e",
  strokeWidth: 4
}, /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 22,
  stroke: "none"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 22,
  cy: 22,
  r: 20,
  fill: "none"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Component_26_4",
  "data-name": "Component 26 \\u2013 4",
  transform: "translate(156 362)"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_12",
  "data-name": "Line 12",
  x2: 12,
  y2: 12,
  fill: "none",
  stroke: "#e94e4e",
  strokeLinecap: "round",
  strokeWidth: 4
}), /*#__PURE__*/React.createElement("g", {
  id: "Component_25_1",
  "data-name": "Component 25 \\u2013 1"
}, /*#__PURE__*/React.createElement("line", {
  id: "Line_13",
  "data-name": "Line 13",
  y1: 12,
  x2: 12,
  fill: "none",
  stroke: "#e94e4e",
  strokeLinecap: "round",
  strokeWidth: 4
}))));

var SvgWarningCircle = function SvgWarningCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWarningCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/warning-circle.a50686c0.svg";
export { ForwardRef as ReactComponent };